import { type TabId } from "@features/sales-v3/tabs";
import {
  TAB_RANKING,
  TAB_RANKINGS,
} from "@features/sales-v3/tabs/constants/tab";

export function getNextTabId(tab: TabId) {
  const currentTabIndex = TAB_RANKINGS[tab] - 1;
  return TAB_RANKING[currentTabIndex + 1];
}
